import {OfferType} from "../../../types/OfferType";
import {ISelectedRegionEstimatedPrice} from "../../actions/fetch_selected_region_estimated_price";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {commercialOffersLocationGenericDescription} from "./commercial_offers_location_generic_description";
import {flatOffersLocationGenericDescription} from "./flat_offers_location_generic_description";
import {houseOffersLocationGenericDescription} from "./house_offers_location_generic_description";
import {mixedOffersLocationGenericDescription} from "./mixed_offers_location_generic_description";
interface IParams {
    offerType: OfferType;
    filters?: {
        rooms_0?: number;
        rooms_1?: number;
    } | null;
    region: ISelectedRegion;
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
}

const isExactStudioFlatFilter = (filters: IParams["filters"]): boolean => filters?.rooms_1 === 1 && (filters.rooms_0 == null || filters.rooms_0 === 1);

const isExactMultiRoomFlatFilter = (filters: IParams["filters"]): boolean =>
    filters?.rooms_1 != null && [2, 3, 4].includes(filters.rooms_1) && filters.rooms_0 === filters.rooms_1;

export const getLocationGenericDescription = ({offerType, filters, region, selectedRegionEstimatedPrices}: IParams) => {
    const descriptionProps = {region, selectedRegionEstimatedPrices};

    switch (offerType) {
        case OfferType.COMMERCIAL:
            return commercialOffersLocationGenericDescription(descriptionProps);
        case OfferType.FLAT:
            if (isExactStudioFlatFilter(filters)) {
                return [];
            }
            if (isExactMultiRoomFlatFilter(filters)) {
                return [];
            }
            return flatOffersLocationGenericDescription(descriptionProps);
        case OfferType.HOUSE:
            return houseOffersLocationGenericDescription(descriptionProps);
        default:
            return mixedOffersLocationGenericDescription(descriptionProps);
    }
};
import {OfferType} from "../../../types/OfferType";
import {ISelectedRegionEstimatedPrice} from "../../actions/fetch_selected_region_estimated_price";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {commercialOffersLocationGenericDescription} from "./commercial_offers_location_generic_description";
import {flatOffersLocationGenericDescription} from "./flat_offers_location_generic_description";
import {houseOffersLocationGenericDescription} from "./house_offers_location_generic_description";
import {mixedOffersLocationGenericDescription} from "./mixed_offers_location_generic_description";
interface IParams {
    offerType: OfferType;
    filters?: {
        rooms_0?: number;
        rooms_1?: number;
    } | null;
    region: ISelectedRegion;
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
}

const isExactStudioFlatFilter = (filters: IParams["filters"]): boolean => filters?.rooms_1 === 1 && (filters.rooms_0 == null || filters.rooms_0 === 1);

const isExactMultiRoomFlatFilter = (filters: IParams["filters"]): boolean =>
    filters?.rooms_1 != null && [2, 3, 4].includes(filters.rooms_1) && filters.rooms_0 === filters.rooms_1;

export const getLocationGenericDescription = ({offerType, filters, region, selectedRegionEstimatedPrices}: IParams) => {
    const descriptionProps = {region, selectedRegionEstimatedPrices};

    switch (offerType) {
        case OfferType.COMMERCIAL:
            return commercialOffersLocationGenericDescription(descriptionProps);
        case OfferType.FLAT:
            if (isExactStudioFlatFilter(filters)) {
                return [];
            }
            if (isExactMultiRoomFlatFilter(filters)) {
                return [];
            }
            return flatOffersLocationGenericDescription(descriptionProps);
        case OfferType.HOUSE:
            return houseOffersLocationGenericDescription(descriptionProps);
        default:
            return mixedOffersLocationGenericDescription(descriptionProps);
    }
};
